let _ = t => t,
  _t;
import { match } from 'ts-pattern';
import styled, { css } from 'styled-components';
import TextBox from '../TextBox';
import fonts from '../styles/fonts';
import fontStack from '../styles/fontStack';
import fontWeights from '../styles/fontWeights';
/**
 * Returns the CSS rules for each variant depending on the screen size:
 *
 *      font-size: (n)px
 *      line-height: (n)px
 *      letter-spacing: (n)em
 *
 * Mapping display font sizes to headline styles:
 * https://www.figma.com/file/0ot53XzazhcUOQTZta4wP3/Design-System-1.0?type=design&node-id=6175-377486
 */

const matchFontStyles = (variant, isMd) => match(variant).with('textLg', v => isMd ? fontStack[v] : fontStack.textMd).with('displayMd', v => isMd ? fontStack[v] : fontStack.displaySm).with('displayLg', 'displayXl', 'display1xl', 'display2xl', v => isMd ? fontStack[v] : fontStack.displayMd).otherwise(v => fontStack[v]);

/**
 * Returns the default font weight depending on the variant and weight passed.
 * For display headlines, we are limiting weights to medium and semibold.
 * For text, we have regular, medium and semibold available.
 *
 * https://www.figma.com/file/0ot53XzazhcUOQTZta4wP3/Design-System-1.0?type=design&node-id=6175-377487
 */

const matchFontWeight = (variant, weight) => {
  if (weight === undefined) {
    return match(variant).with('textXs', 'textSm', 'textMd', 'textLg', () => fontWeights.regular).otherwise(() => fontWeights.medium);
  }
  return match([variant, weight]).when(([v, w]) => /display/.test(v) && !['medium', 'semiBold'].includes(w), () => fontWeights.medium).otherwise(([, w]) => fontWeights[w]);
};

//

export const Text = styled(TextBox)(({
  isMd,
  $variant: variant,
  $weight: weight,
  $color: color,
  $inline
}) => {
  const fontStyles = matchFontStyles(variant, isMd);
  const fontWeight = matchFontWeight(variant, weight);
  return css(_t || (_t = _`
        display: ${0};

        color: ${0};
        font-weight: ${0};
        font-size: ${0};
        font-family: ${0};
        line-height: ${0};
        letter-spacing: ${0};
    `), $inline ? 'inline-block' : 'block', color, fontWeight, fontStyles.fontSize, fonts.basic, fontStyles.lineHeight, fontStyles.letterSpacing);
});